<template>

  <div class="row" style="height: 100vh">

    <div class="col-3" id="app">
      <div>
        <div class="mb-2">
          <button type="button" class="btn btn-outline-primary" @click="addTable">Add table</button>


          <div class="d-inline-block imageuploader">
            <input type="file" @change="previewImage" accept="image/*">
            <button type="button" class="btn btn-outline-secondary" @click="uploadImage">Upload image</button>
          </div>
        </div>
        <div class="list-group" v-if="!selectedTable">
          <a href="#" class="list-group-item list-group-item-action flex-column align-items-start" :class="{'active': table.hovered}" v-for="table, n in tables" :key="n">
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1">{{table.title}}</h5>
              <small>{{table.size}}</small>
            </div>
            <!--<p class="mb-1">Donec id elit non mi porta gravida at eget metus. Maecenas sed diam eget risus varius blandit.</p>-->
            <!--<small>Donec id elit non mi porta.</small>-->
          </a>
        </div>
        <div v-else>
          <div class="form-group">
            <label>Title</label>
            <input type="text" class="form-control" @input="onChange" v-model="selectedTable.title" placeholder="Title">
          </div>
          <div class="form-group">
            <label>Size</label>
            <div>
              <input type="number" min="1" max="1000" class="form-control" @input="onChange" v-model="selectedTable.size" placeholder="Size">
            </div>
          </div>

          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" @change="onChange" id="customCheck1" v-model="selectedTable.hasExtra">
              <label class="custom-control-label" for="customCheck1">Extra places</label>
            </div>
          </div>

          <div class="form-group" v-if="selectedTable.hasExtra">
            <label>Extra places</label>
            <div>
              <input type="number" min="1" max="1000" class="form-control" @input="onChange" v-model="selectedTable.extraPlaces" placeholder="">
            </div>
          </div>

          <div class="form-group">
            <label>Priority</label>
            <div>
              <input type="number" min="1" max="1000" class="form-control" @input="onChange" v-model="selectedTable.priority" placeholder="">
            </div>
          </div>

          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" @change="onChange" id="customCheck2" v-model="selectedTable.avaliable">
              <label class="custom-control-label" for="customCheck2">Avaliable for booking</label>
            </div>
          </div>


          <el-button type="danger" size="small" @click="deleteTable(selectedTable)">
            <i class="el-icon-delete"></i>
            Delete table
          </el-button>

        </div>
      </div>
    </div>
    <div class="col-9">

      <div id="cc">
        <canvas id="c"></canvas>
      </div>
    </div>

  </div>
</template>
<style>
  #c, #cc{
    width: 100%;
    height: 100%;
  }
  .imageuploader {
    position: relative;
    overflow: hidden;
    vertical-align: bottom;
  }
  .imageuploader [type="file"] {
    position: absolute;
    font-size: 200px;
    opacity: 0;
  }
  .el-button-group+.el-button-group {
    margin-left: 10px;
  }
</style>
<script>
import 'fabric'
import _ from 'lodash';

let canvas, selectedObject, saveTimer;

export default {
  props: ['room'],
  components: {
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    }
  },
  data() {
    return {
      tables: [],
      selectedTable: null
    }
  },
  mounted() {
    canvas = new fabric.Canvas('c');

    resize();
    window.addEventListener('resize', () => {
      setTimeout(resize, 1)
    });

    canvas.loadFromJSON(this.room.settings || '', function() {
      canvas.renderAll();
    }, (o,object) => {
      var tableItem = prepareTableItem({
        title: o.title,
        size: o.size,
        avaliable: o.avaliable,
        hasExtra: o.hasExtra,
        extraPlaces: o.extraPlaces,
        priority: o.priority
      });
      this.tables.push(tableItem);
      object.tableItem = tableItem;
      object.toObject = toObjectGroup(object.toObject);
      object.update = updateGroupData;
    });

    canvas.on({
      'object:moving' : this.saveChanges,
      'object:modified' : this.saveChanges,
      'mouse:move': (e) => {
        this.tables.forEach(table => table.hovered = false);
        if (e.target && e.target.tableItem) {
          e.target.tableItem.hovered = true;
        }
      },
      "selection:cleared": (e) => {
        this.selectedTable = null;
      },
      "selection:updated": onSelect,
      "selection:created": onSelect
    });

    var app = this;
    function onSelect(e) {
      if (e.selected.length === 1) {
        selectedObject = e.selected[0];
        app.selectedTable = e.selected[0].tableItem;
      }
    }

    function resize() {
      var container = document.getElementById('cc');
      canvas.setWidth(container.offsetWidth);
      canvas.setHeight(container.offsetHeight);
      canvas.calcOffset();
    }
  },
  methods: {
    saveChanges() {
      this.room.settings = JSON.stringify(canvas);

      if (saveTimer) {
        return;
      }

      saveTimer = setTimeout(() => {
        this.$emit('saved');
        saveTimer = null;
      }, 100);
    },
    onChange() {
      selectedObject.update(this.selectedTable);
      this.saveChanges();
    },
    deleteTable(table) {
      this.tables = _.without(this.tables, table);
      canvas.remove(selectedObject);
      this.saveChanges();
    },
    addTable() {
      var table = createTable(`${this.tables.length + 1}`, '2');

      var tableItem = prepareTableItem({
        title: `${this.tables.length + 1}`,
        size: '2',
        priority: this.tables.length + 1
      });
      this.tables.push(tableItem);
      table.tableItem = tableItem;
      table.toObject = toObjectGroup(table.toObject);
      table.update = updateGroupData;
      canvas.add(table).setActiveObject(table);
      this.saveChanges();
    },
    uploadImage() {

    },
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          fabric.Image.fromURL(e.target.result, (img) => {
            // add background image
            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
              scaleX: 800 / img.width,
              scaleY: 800 / img.width
            });
            this.saveChanges();
          });
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);

      }
    }
  }
};


function createTable(title, size) {
  var rect = new fabric.Rect({
    left: 0,
    top: 0,
    width: 150,
    height: 120,
    fill: 'rgba(200,200,200,0.5)',
    transparentCorners: false,
    originX: 'center',
    originY: 'center'
  });
  var itext = new fabric.IText(title, {
    left: 0,
    top: 0,
    width: 150,
    height: 120,
    fontSize: 60,
    fill: '#000',
    originX: 'center',
    originY: 'center'
  });
  var places = new fabric.Text(size, {
    left: 75,
    top: 60,
    width: 150,
    height: 120,
    fontSize: 30,
    fill: '#000',
    textAlign: 'right',
    originX: 'right',
    originY: 'bottom'
  });

  var group = new fabric.Group([ rect, itext, places ], {
    left: 150,
    top: 100
  });
  group.toObject = toObjectGroup(group.toObject);
  group.update = updateGroupData;

  group.tableItem = { title, size };
  return group;
}

function toObjectGroup(toObject) {
  return function() {
    return fabric.util.object.extend(toObject.call(this), {
      title: this.tableItem.title,
      size: this.tableItem.size,
      avaliable: this.tableItem.avaliable,
      hasExtra: this.tableItem.hasExtra,
      extraPlaces: this.tableItem.extraPlaces,
      priority: this.tableItem.priority
    });
  };
}

function updateGroupData(data) {
  this.item(1).set('text', data.title);

  var size = data.size;
  if (data.hasExtra && data.extraPlaces) {
    size += ` (+${data.extraPlaces})`;
  }
  this.item(2).set('text', size);

  canvas.renderAll();
}

function prepareTableItem(o) {
  return {
    title: o.title,
    size: o.size,
    hovered: false,
    avaliable: o.avaliable,
    hasExtra: o.hasExtra,
    extraPlaces: o.extraPlaces,
    priority: o.priority
  };
}

</script>



// WEBPACK FOOTER //
// ManageRoom.vue?7f5e1048